import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.white,
  textColor: colors.slateGrey,
  textColorDark: colors.slateGrey,
  textColorLight: colors.white
};
export default pencilBanner;